function validateFreeMonogramming(input) {
  var texto = input.value.trim().replace(/[^a-zA-Z.]/g, "");
  if (texto.startsWith(".")) texto = texto.substring(1);
  var letras = texto.replace(/\./g, "").length;
  if (letras > 3) texto = texto.substring(0, texto.length - (letras - 3));
  if (texto.length > 6) texto = texto.substring(0, 6);
  input.value = texto;
}

function addFreeItemToCart() {
  var input = document.getElementById("monogramming-free");
  var msgEl = document.getElementById("mono-free-msg");
  var texto = input.value
    .trim()
    .replace(/[^a-zA-Z.]/g, "")
    .toUpperCase();
  var letras = texto.replace(/\./g, "").length;

  if (letras < 2) {
    msgEl.textContent = "Escribe 2 ó 3 letras (con o sin puntos)";
    msgEl.style.display = "block";
    input.focus();
    return false;
  }

  msgEl.style.display = "none";

  var form = document.querySelector("form.product-purchase-form");
  if (!form) return false;

  // Inject or update the hidden property input in the product form
  var propInput = form.querySelector(
    'input[name="properties[Personalizacion]"]',
  );
  if (!propInput) {
    propInput = document.createElement("input");
    propInput.type = "hidden";
    propInput.name = "properties[Personalizacion]";
    form.appendChild(propInput);
  }
  propInput.value = texto;

  // Close this modal and let the theme's native AJAX handler do the rest
  document.body.classList.remove("modal-active-customize-free");

  // Click the form's native add-to-cart button so the theme handles the cart modal and count
  var addBtn = form.querySelector('button[type="submit"][name="add"]');
  if (addBtn) addBtn.click();

  return false;
}
